import { Action, createReducer, on } from "@ngrx/store";

import { ConsumerCountLoaded, ConsumerCountRequestFailed } from "../actions/consumer.actions";
import { CountState } from "../models/count-state";

const initialState: CountState = {
	count: 0,
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerCountLoaded, (state, action) => ({ ...state, ...action.consumerCountState })),
	on(ConsumerCountRequestFailed, (state, action) => ({
		...state,
		error: action.error,
		loading: false
	}))
);

export function consumerCountReducer(state: CountState | undefined, action: Action): CountState {
	return reducer(state, action);
}
